export default function anonymous(context
) {
var out='';var arr1=context.object.matchers;if(arr1){var matcher,i1=-1,l1=arr1.length-1;while(i1<l1){matcher=arr1[i1+=1];out+=''+( matcher.print('text') );} } return out;
}